import EnterpriseFeatureLanding from '../../../shared/enterprise-upsell-page/enterprise-upsell-landing-page';
import RulesEngineVideoCardBackground from '../../../shared/enterprise-upsell-page/rules-engine-video-card-background';

import PlayArrow from '@mui/icons-material/PlayArrow';
import SpaceDashboardOutlined from '@mui/icons-material/SpaceDashboardOutlined';

export default function RulesEngineEnterpriseLanding() {
  return (
    <EnterpriseFeatureLanding
      title="Rules Engine"
      description="Automate your workflow with powerful, flexible rules. Build complex
            automations in minutes, not hours."
      topButtons={[
        {
          label: 'Rule Management',
          icon: <SpaceDashboardOutlined />,
          variant: 'contained',
          mediaLink: 'https://play.hubspotvideo.com/v/22148155/id/224562200610',
        },
        {
          label: 'Creation Flow',
          icon: <PlayArrow />,
          variant: 'outlined',
          mediaLink: 'https://play.hubspotvideo.com/v/22148155/id/224562181672',
        },
      ]}
      featuresDescription={[
        'Automate repetitive tasks instantly',
        'Scale operations effortlessly',
        'Reduce manual errors by 95%',
      ]}
      learnMoreHref="https://gpanel.io/knowledge/automation/manage-rules-engine"
      videoCardBackground={<RulesEngineVideoCardBackground />}
    />
  );
}
